import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f47edfea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f47edfea&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=f47edfea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47edfea",
  null
  
)

export default component.exports